import React from "react";
import "./HeroSection.css";

import WhatsappLogo from "../../assets/images/whatsapplogo.png";

const HeroSection = (props) => {
  return (
    <div className={props.cName || "hero-section"}>
      <img src={props.heroImg} alt="Workers" className="hero-image" />

      <div className="hero-text">
        <div className="hero-content-wrapper">
          <div className="hero-heading-box">
            <h1>{props.title}</h1>
            <p>{props.text}</p>
          </div>

          {props.sideText && (
            <div className="hero-side-box">
              <p>{props.sideText}</p>
            </div>
          )}
        </div>

        {props.qrImg ? (
          <div className="hero-qr-container">
            {!props.qrImg.includes("qr-code-reviews") && (
              <span className="qr-label-text">
                Scan for
                <img src={WhatsappLogo} alt="WhatsApp" className="qr-inline-logo" />
              </span>
            )}
            <img src={props.qrImg} alt="QR Code" className="hero-qr-img" />
          </div>
        ) : (
          props.buttonText && (
            <a href={props.url} className={props.btnClass || "show"}>
              {props.buttonText}
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default HeroSection;
